package com.platforma.chat_domain

enum class MessageStatus {
    Pending,
    Sending,
    Delivered,
    Failed,
    Printing
}